import { render, staticRenderFns } from "./QTHDistribution.vue?vue&type=template&id=db14bcb8"
import script from "./QTHDistribution.vue?vue&type=script&lang=js"
export * from "./QTHDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports